import { Action } from '@ngrx/store';
import { Form } from 'app/models/form.model';

export enum FormsActionTypes {
  LoadFormsData = '[Forms] Load',
  LoadFormsDataSuccess = '[Forms] Load success',
  LoadFormsDataFail = '[Forms] Load fail',
  }
  
  export class LoadForms implements Action {
    readonly type = FormsActionTypes.LoadFormsData;
    constructor() {}
  }
  
  export class LoadFormsSuccess implements Action {
    readonly type = FormsActionTypes.LoadFormsDataSuccess;
    constructor(public payload: Form[]) {}
  }
  
  export class LoadFormsFail implements Action {
    readonly type = FormsActionTypes.LoadFormsDataFail;
    constructor(public payload: any) {}
  }

  export type FormsActions =
  | LoadForms
  | LoadFormsSuccess
  | LoadFormsFail;